import { gql } from "@apollo/client";

export const SESSION_HEARTBEAT = gql`
  mutation SessionHeartbeat {
    sessionHeartbeat
  }
`;
